import React from 'react';
import cn from 'classnames';
import Color from 'color';
import { ContentBlocks } from './ContentBlock';
import { Image } from '../components/Image';
import { findByType } from '../utils';
import './HeroBlock.scss';
const parseAlignment = (alignment) => {
    if (alignment.includes('top')) {
        return 'flex-start';
    }
    if (alignment.includes('bottom')) {
        return 'flex-end';
    }
    return 'center';
};
// eslint-disable-next-line complexity
export function HeroBlock({ data }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const id = (_a = findByType(data.value.config, 'id')) === null || _a === void 0 ? void 0 : _a.value;
    const textAlign = (_b = findByType(data.value.config, 'text_alignment')) === null || _b === void 0 ? void 0 : _b.value;
    const backgroundColor = (_c = findByType(data.value.config, 'background_color')) === null || _c === void 0 ? void 0 : _c.value;
    const padding = (_e = (_d = findByType(data.value.config, 'padding')) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : 0;
    const paddingTop = (_f = findByType(data.value.config, 'padding_top')) === null || _f === void 0 ? void 0 : _f.value;
    const paddingBottom = (_g = findByType(data.value.config, 'padding_bottom')) === null || _g === void 0 ? void 0 : _g.value;
    const analytics = (_h = findByType(data.value.config, 'analytics_label')) === null || _h === void 0 ? void 0 : _h.value;
    const isDark = backgroundColor && Color(backgroundColor).isDark(); // eslint-disable-line new-cap
    const alignment = (_k = (_j = findByType(data.value.config, 'image_alignment')) === null || _j === void 0 ? void 0 : _j.value.toLowerCase()) !== null && _k !== void 0 ? _k : 'right';
    const imageRight = alignment.includes('right');
    const imageVerticalAlign = parseAlignment(alignment);
    return React.createElement("section", { id: id, className: cn('content-block-hero', { 'dark-background': isDark }), "data-analytics-nav": analytics, style: { backgroundColor,
            '--padding-multiplier': padding,
            '--padding-top-multiplier': paddingTop,
            '--padding-bottom-multiplier': paddingBottom,
            '--image-vertical-align': imageVerticalAlign
        } },
        React.createElement("div", { className: "hero-inner-wrapper" }, imageRight ? React.createElement(React.Fragment, null,
            React.createElement("div", { className: "hero-content", style: { textAlign } },
                React.createElement(ContentBlocks, { data: data.value.content })),
            React.createElement("div", { className: "hero-image-container" },
                React.createElement(Image, { className: "hero-image", image: data.value.image, alt: data.value.imageAlt }))) : React.createElement(React.Fragment, null,
            React.createElement("div", { className: "hero-image-container" },
                React.createElement(Image, { className: "hero-image", image: data.value.image, alt: data.value.imageAlt })),
            React.createElement("div", { className: "hero-content", style: { textAlign } },
                React.createElement(ContentBlocks, { data: data.value.content })))));
}
